import * as React from 'react';

export const BottomArrow: React.FC<{ fill?: string }> = ({ fill = 'white' }) => (
  <svg width="16" height="6" viewBox="0 0 16 6" fill="none">
    <path d="M8 0L16 6H0L8 0Z" fill={fill} />
  </svg>
);
